

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';

const TrackingModal = ({
  open,
  onClose,
  onConfirm,
  disableConfirm = false // optional prop
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Notice</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" component="div">
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            <li>This order still requires shipping carrier and tracking #.</li>
            <li>Order is now located in the Needs Tracking # queue.</li>
          </ul>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} 
        sx={{
    backgroundColor: '#ec008c',
    color: 'white',
    '&:hover': {
      backgroundColor: '#d5006d',
    },
  }}>Cancel</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          //color="primary"
          sx={{
              backgroundColor: '#ec008c',
              color: 'white',
              '&:hover': {
                backgroundColor: '#d5006d',
              },
            }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrackingModal;
